/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SalesTable from "./SalesTable";
import DataTable from "./DataTable";
import { FormTitle,Fieldset,SelectFields } from "ui-components/Form";

// Sales dashboard components
import ChannelsChart from "./components/ChannelsChart";
import { useEffect } from "react";
import { useMaterialUIController, setMiniSidenav } from "context";
import { getKPIPicker,getKPITeamConfig,getKPITeamName,getKPIQC,retrieveKPIDashboardList } from "services/data.kpi.service";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useTheme } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";
import { LinearProgress, Typography, Box } from "@mui/material";
import { styled } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import { CustomDateRangePicker } from "ui-components/CustomInput";
import dayjs from "dayjs";
import { useTeamValue } from "providers/TeamContext";

function KPIDashboard() {
  const [kpiteamname, setKPITeamName] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedrefreshrate, setSelectedRefreshRate] = useState("20");
  const [updatedConfigList, setUpdatedConfigList] = useState([]);
  const isConfigReady = updatedConfigList.length > 0;
  const [showFirstTable, setShowFirstTable] = useState(true);
  const [orderAssignData, setOrderAssignData] = useState({
    titles: [],
    labels: [],
    datasets: {
      label: '',
      backgroundColors: [],
      data: [],
    },
  });
  const [quantityAssignData, setQuantityAssignData] = useState({
    titles: [],
    labels: [],
    datasets: {
      label: '',
      backgroundColors: [],
      data: [],
    },
  });
  const [qcorderAssignData, setQCOrderAssignData] = useState({
    titles: [],
    labels: [],
    datasets: {
      label: '',
      backgroundColors: [],
      data: [],
    },
  });
  const [qcquantityAssignData, setQCQuantityAssignData] = useState({
    titles: [],
    labels: [],
    datasets: {
      label: '',
      backgroundColors: [],
      data: [],
    },
  });

  const {permissions, allowAll} = useTeamValue();
  const exportPermission =
    allowAll ||
    (Boolean(permissions["KPI Productivity_Report"]) &&
      permissions["KPI Productivity_Report"].findIndex((b) => b === "export") !== -1);

  let currentDate = new Date();
  const [dateEnd, setDateEnd] = useState(new Date(currentDate));
  const [dateStart, setDateStart] = useState(
    new Date(currentDate.setDate(currentDate.getDate() - 7))
  );
  const customProps = {
    startDate: dateStart,
    setStartDate: setDateStart,
    endDate: dateEnd,
    setEndDate: setDateEnd,
  };

  useQuery({
    queryKey: ["kpi-team-name"],
    queryFn: () => getKPITeamName(),
    onSuccess: (data) => {
      //console.log(data,"kpiteamname");
      const teamOptions = data.data.data // data structure: data -> data -> array of teams
        .filter(item => item.team) // remove nulls
        .map((item, index) => ({
          label: item.team,
          value: item.team, // you can also use index or ID if available
        }));
      setKPITeamName(teamOptions);
    },
    // onSuccess: (data) => {
    //   console.log(data);
    //   setKPITeamName(data.data.team);
    // },
    onError: () => { },
  });

  const formatDate = (date) => {
    return date instanceof Date ? date.toISOString().split("T")[0] : date;
  };
  
  const handleDownload = async () => {
    try {
      const result = await retrieveKPIDashboardList({
        startdate: formatDate(customProps.startDate),
        enddate: formatDate(customProps.endDate),
        teamname: selectedTeam
      });
  
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
  
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `KPIDashboard_${selectedTeam}_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to fetch KPI Dashboard data", error);
    }
  };
  

 const queryClient = useQueryClient();
   useQuery({
        queryKey: ["pickers-kpi", { selectedTeam }],
        queryFn: () => getKPIPicker({ customer: selectedTeam }),
        // enabled: !!selectedrefreshrate && selectedTeam !== "",
        // refetchInterval: selectedrefreshrate ? parseInt(selectedrefreshrate) * 1000 : false, 
        enabled: selectedTeam !== "", // only disable if team is empty
  refetchInterval: 10000, // refresh every 10 seconds
        onSuccess: (data) => {
          //console.log("kpi picker data",data);
          const kpiArray = data.data.data; // Access the array
          const newRows = kpiArray.map(item => {
            

            const rawQtyPerMin = typeof item.pickQtyPerMin === 'string'
              ? item.pickQtyPerMin.replace(',', '.')
              : item.pickQtyPerMin;
          
            const qtyPerMin = parseFloat(rawQtyPerMin);
            //console.log('qtyPerMin:', item.pickQtyPerMin, '=> parsed:', qtyPerMin);
            return {
              user: item.rfUserID,
              orderdone: item.pickCount,
              ordertotal: item.assignCount,
              done: item.pickQty,
              total: item.assignQty,
              //adsSpent: Math.ceil(parseFloat(item.minTaken) / 60),
              //adsSpent: Math.ceil(parseFloat(item.minTaken) * 10) / 10,
              adsSpent: `${(parseFloat(item.minTaken) / 60).toFixed(1)}`,
              // quantity: Math.ceil(item.assignQty/Math.ceil(parseFloat(item.minTaken) / 60)),
              // // quantity2: isNaN(qtyPerMin)
              // //   ? 0
              // //   : Math.min(Math.ceil(qtyPerMin * 60), 9999), //quantity picker productivity
              // //refunds2: Math.ceil(parseFloat(item.pickCountPerMin) * 60), //order picker productivity
              // refunds: Math.ceil(item.assignCount/Math.ceil(parseFloat(item.minTaken) / 60)),

              quantity : parseFloat(item.minTaken) > 0
  ? Math.ceil(item.pickQty / (parseFloat(item.minTaken)/60).toFixed(1))
  : 0,

refunds : parseFloat(item.minTaken) > 0
  ? Math.ceil(item.pickCount / (parseFloat(item.minTaken)/60).toFixed(1))
  : 0,
            };
          });
      
          
          // Update state
          setTableData(prev => ({
            ...prev,
            rows: newRows
          }));

          const totalAssigned = newRows.reduce((sum, row) => sum + row.ordertotal, 0);
const totalCompleted = newRows.reduce((sum, row) => sum + row.orderdone, 0);
const totalIncomplete = totalAssigned - totalCompleted;

          setOrderAssignData({
            titles: ["Productivity Range of Orders Assigned and Picked"],
            labels: ["Completed", "Incomplete"],
            datasets: {
              label: "Projects",
              backgroundColors: ["info", "primary"],
              data: [totalCompleted, totalIncomplete],
            },
          });
          const totalQuantityAssigned = newRows.reduce((sum, row) => sum + row.total, 0);
          const totalQuantityCompleted = newRows.reduce((sum, row) => sum + row.done, 0);
          const totalQuantityIncomplete = totalQuantityAssigned - totalQuantityCompleted;
          setQuantityAssignData({
            titles: ["Productivity Range of Quantity Items Assigned and Picked"],
            labels: ["Completed", "Incomplete"],
            datasets: {
              label: "Projects",
              backgroundColors: ["info", "primary"],
              data: [totalQuantityCompleted, totalQuantityIncomplete],
            },
          });
        },
        onError: () => { },
      })

      useQuery({
        queryKey: ["kpi-team-config"],
        queryFn: () => getKPITeamConfig({ team: selectedTeam }),
        enabled: !!selectedrefreshrate && selectedTeam !== "",
        onSuccess: (data) => {
          //console.log(data);
          const config = data.data?.data?.[0]; // assuming the API returns an array and you want the first one
          //console.log(config,'retrievedata');
  // Parse userRange and productivityRange
  const parseRangeString = (rangeStr) => {
    const rawPairs = rangeStr
    .split(";")
    .map(pair => pair.split(",").map(Number));

  // Filter out [0, 0] pairs
  const pairs = rawPairs.filter(([start, end]) => !(start === 0 && end === 0));
    //const pairs = rangeStr.split(",").map(pair => pair.split(";").map(Number));
    const labels = [];

    //console.log(pairs,"pairs");
    if (pairs.length > 0) {
      // Group 1: < first lower bound
      labels.push(`<${pairs[0][0]}`);
    }

    // Middle ranges
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i];
  
      if (pair.length !== 2) continue; // Skip if not a valid pair with 2 values
    
      const [start, end] = pair;
      if (i === 0) continue; // skip first (already used as <)
      labels.push(`${start}~${end}`);
    }

    // Last group: > last upper bound
    const lastPair = pairs[pairs.length - 1];
    if (lastPair.length === 1) {
      labels.push(`>${lastPair[0]}`);
    } else if (lastPair.length === 2) {
      labels.push(`>${lastPair[1]}`);
    }

    return labels;
  };

  const userLabels = parseRangeString(config.userRange);
  const prodLabels = parseRangeString(config.productivityRange);

  const updatedConfigList = configList.map((item, index) => {
    const labels = index === 0 ? userLabels : prodLabels;

    return {
      ...item,
      data: labels.map((label, i) => ({
        label,
        color: item.data[i]?.color || "#ccc", // fallback color
      })),
    };
  });
  setUpdatedConfigList(updatedConfigList);
  //console.log("Updated Config List:", updatedConfigList);
        },
        onError: () => { },
      })

      useQuery({
        queryKey: ["qc-kpi", { selectedTeam }],
        queryFn: () => getKPIQC({ customer: selectedTeam }),
        // enabled: !!selectedrefreshrate && selectedTeam !== "",
        // refetchInterval: selectedrefreshrate ? parseInt(selectedrefreshrate) * 1000 : false, 
        enabled: selectedTeam !== "", // only disable if team is empty
  refetchInterval: 10000, // refresh every 10 seconds
        onSuccess: (data) => {
          //console.log("kpi qc data",data);
          const kpiArray = data.data.data; // Access the array
          const newRows = kpiArray.map(item => {
            

            const rawQtyPerMin = typeof item.packQtyPerMin === 'string'
              ? item.packQtyPerMin.replace(',', '.')
              : item.packQtyPerMin;
          
            const qtyPerMin = parseFloat(rawQtyPerMin);
            return {
              user: item.rfUserID,
              orderdone: item.packCount,
              ordertotal: item.assignCount,
              done: item.packQty,
              total: item.assignQty,
              //adsSpent: Math.ceil(parseFloat(item.minTaken)),
              adsSpent: `${(parseFloat(item.minTaken)).toFixed(1)}`,
              //adsSpent: Math.ceil(parseFloat(item.minTaken) * 10) / 10,
              // quantity: isNaN(qtyPerMin)
              //   ? 0
              //   : Math.min(Math.ceil(qtyPerMin * 60), 9999),
                //quantity2: Math.ceil(qtyPerMin),
              //   quantity: Math.ceil(item.packQty/Math.ceil(parseFloat(item.minTaken))),
              // //refunds2: Math.ceil(parseFloat(item.packCount/item.minTaken)), //for orderqc productivity per hour
              // refunds: Math.ceil(item.packCount/Math.ceil(parseFloat(item.minTaken))),
              quantity : parseFloat(item.minTaken) > 0
  ? Math.ceil(item.packQty /(parseFloat(item.minTaken).toFixed(1)))
  : 0,

refunds : parseFloat(item.minTaken) > 0
  ? Math.ceil(item.packCount / (parseFloat(item.minTaken).toFixed(1)))
  : 0,
//               quantity : parseFloat(item.minTaken) > 0
//   ? Math.ceil(item.packQty / Math.ceil(parseFloat(item.minTaken)))
//   : 0,

// refunds : parseFloat(item.minTaken) > 0
//   ? Math.ceil(item.packCount / Math.ceil(parseFloat(item.minTaken)))
//   : 0,
            };
          });
          //console.log(newRows,"new rows");
      
          // Update state
          setQCTableData(prev => ({
            ...prev,
            rows: newRows
          }));

           const totalAssigned = newRows.reduce((sum, row) => sum + row.ordertotal, 0);
 const totalCompleted = newRows.reduce((sum, row) => sum + row.orderdone, 0);
 const totalIncomplete = totalAssigned - totalCompleted;
           setQCOrderAssignData({
             titles: ["Productivity Range of Orders QC"],
             labels: ["Completed", "Incomplete"],
             datasets: {
               label: "Projects",
               backgroundColors: ["info", "primary"],
               data: [totalCompleted, totalAssigned],
             },
           });
           const totalQuantityAssigned = newRows.reduce((sum, row) => sum + row.total, 0);
           const totalQuantityCompleted = newRows.reduce((sum, row) => sum + row.done, 0);
           const totalQuantityIncomplete = totalQuantityAssigned - totalQuantityCompleted;
           setQCQuantityAssignData({
             titles: ["Productivity Range of Quantity Items QC"],
             labels: ["Completed", "Incomplete"],
             datasets: {
               label: "Projects",
               backgroundColors: ["info", "primary"],
               data: [totalQuantityCompleted, totalAssigned],
             },
           });
        },
        onError: () => { },
      })

  const configList = [
    {
      title: "User KPI (%)",
      data: [
        { label: "<10", color: "#e74c3c" },
        { label: "11~20", color: "#f39c12" },
        { label: ">81", color: "#f1c40f" },
        { label: "<10", color: "#00bcd4" },
        { label: "11~30", color: "#2ecc71" },
      ],
    },
    {
      title: "Productivity Hour (%)",
      data: [
        { label: "<10", color: "#e74c3c" },
        { label: "11~20", color: "#f39c12" },
        { label: ">81", color: "#f1c40f" },
        { label: "<10", color: "#00bcd4" },
        { label: "11~30", color: "#2ecc71" },
      ],
    },
  ];
  
  const formattedConfigList = updatedConfigList.map(cfg => ({
    title: cfg.title,
    rows: cfg.data.map(item => ({
      value: item.label,
      color: item.color,
    })),
  }));

  const [tableData, setTableData] = useState({
    columns: [
      {
        Header: "User ID",
        accessor: "user",
        Cell: ({ row }) => (<MDTypography variant="h6" fontWeight="bold">
          {row.original.user}
        </MDTypography>),
        width: "10%",
      },
      {
        Header: "Order Picked/Assigned",
        accessor: "order",
        Cell: ({ row }) => <ProgressBarCell done={row.original.orderdone} total={row.original.ordertotal} user={row.original.user} />,
        width: "30%",
      },
      {
        Header: "Quantity Item Picked/Assigned",
        accessor: "value",
        Cell: ({ row }) => <ProgressBarCell done={row.original.done} total={row.original.total} user={row.original.user} />,
        width: "30%",
      },
      {
        Header: "Average Hours",
        accessor: "adsSpent",
        align: "center",
        Cell: ({ value }) => <NumberColorCell value={value} />,
      },
      {
        Header: "Order Productivity Per Hour",
        accessor: "refunds",
        align: "center",
        Cell: ({ value }) => <NumberColorCell value={value} configData={updatedConfigList} configType="User KPI (%)"/>,
      },
      {
        Header: "Quantity Productivity Per Hour",
        accessor: "quantity",
        align: "center",
        Cell: ({ value }) => <NumberColorCell value={value}  configData={updatedConfigList} configType="Productivity Hour (%)"/>,
      },
    ],
    rows: [], // Initially empty
  });

  const [qctableData, setQCTableData] = useState({
    columns: [
      {
        Header: "User ID",
        accessor: "user",
        Cell: ({ row }) => (<MDTypography variant="h6" fontWeight="bold">
          {row.original.user}
        </MDTypography>),
        width: "10%",
      },
      {
        Header: "Orders QC",
        accessor: "order",
        Cell: ({ row }) => <ProgressBarCell2 done={row.original.orderdone} total={row.original.ordertotal} user={row.original.user} />,
        width: "30%",
      },
      {
        Header: "Quantity Item QC",
        accessor: "value",
        Cell: ({ row }) => <ProgressBarCell2 done={row.original.done} total={row.original.total} user={row.original.user} />,
        width: "30%",
      },
      {
        Header: "Average Hours",
        accessor: "adsSpent",
        align: "center",
        Cell: ({ value }) => <NormalColorCell value={value} />,
      },
      {
        Header: "Order QC Productivity Per Hour",
        accessor: "refunds",
        align: "center",
        Cell: ({ value }) => <NumberColorCell value={value} configData={updatedConfigList} configType="Productivity Hour (%)"/>,
      },
      {
        Header: "Quantity QC Productivity Per Hour",
        accessor: "quantity",
        align: "center",
        Cell: ({ value }) => <NumberColorCell value={value}  configData={updatedConfigList} configType="Productivity Hour (%)"/>,
      },
    ],
    rows: [], // Initially empty
  });
  
  const [controller, dispatch] = useMaterialUIController();

  useEffect(() => {
    setMiniSidenav(dispatch, true); // true = collapsed, false = expanded
  }, []);

  useEffect(() => {
    if (!selectedrefreshrate) return;
  
    const interval = setInterval(() => {
      setShowFirstTable(prev => !prev);
    }, parseInt(selectedrefreshrate) * 1000);
  
    return () => clearInterval(interval); // cleanup
  }, [selectedrefreshrate]);

  // When updatedConfigList changes, update columns inside tableData
  useEffect(() => {
    if (!isConfigReady) return;

    const newColumns = [
      {
        Header: "User ID",
        accessor: "user",
        Cell: ({ row }) => (<MDTypography variant="h6" fontWeight="bold">
          {row.original.user}
        </MDTypography>),
        width: "10%",
      },
      {
        Header: "Order Picked/Assigned",
        accessor: "order",
        Cell: ({ row }) => (
          <ProgressBarCell
            done={row.original.orderdone}
            total={row.original.ordertotal}
            user={row.original.user}
            configData={updatedConfigList}
        configType="User KPI (%)"
          />
        ),
        width: "30%",
      },
      {
        Header: "Quantity Item Picked/Assigned",
        accessor: "value",
        Cell: ({ row }) => (
          <ProgressBarCell
            done={row.original.done}
            total={row.original.total}
            user={row.original.user}
            configData={updatedConfigList}
        configType="User KPI (%)"
          />
        ),
        width: "30%",
      },
      {
        Header: "Average Hours",
        accessor: "adsSpent",
        align: "center",
        Cell: ({ value }) => <NormalColorCell value={value} configData={updatedConfigList}
        configType="Productivity Hour (%)"/>,
      },
      {
        Header: "Order Productivity Per Hour",
        accessor: "refunds",
        align: "center",
        Cell: ({ value }) => (
          <NumberColorCell
            value={value}
            configData={updatedConfigList}
            configType="Productivity Hour (%)"
          />
        ),
      },
      {
        Header: "Quantity Productivity Per Hour",
        accessor: "quantity",
        align: "center",
        Cell: ({ value }) => (
          <NumberColorCell
            value={value}
            configData={updatedConfigList}
            configType="Productivity Hour (%)"
          />
        ),
      },
    ];
    //console.log(newColumns,"column picker");
    setTableData(prev => ({
      ...prev,
      columns: newColumns,
      // rows: prev.rows // or update rows if needed
    }));

    const newColumnsQC = [
      {
        Header: "User ID",
        accessor: "user",
        Cell: ({ row }) => (<MDTypography variant="h6" fontWeight="bold">
          {row.original.user}
        </MDTypography>),
        width: "20%",
      },
      {
        Header: "Orders QC",
        accessor: "order",
        Cell: ({ row }) => (
          <ProgressBarCell2
            done={row.original.orderdone}
            total={row.original.ordertotal}
            user={row.original.user}
          />
        ),
        width: "30%",
      },
      {
        Header: "Quantity Item QC",
        accessor: "value",
        Cell: ({ row }) => (
          <ProgressBarCell2
            done={row.original.done}
            total={row.original.total}
            user={row.original.user}
          />
        ),
        width: "30%",
      },
      {
        Header: "Average Hours",
        accessor: "adsSpent",
        align: "center",
        Cell: ({ value }) => <NormalColorCell value={value}
        configType="User KPI (%)"/>,
      },
      {
        Header: "Order QC Productivity Per Hour",
        accessor: "refunds",
        align: "center",
        Cell: ({ value }) => (
          <NumberColorCell
            value={value}
            configData={updatedConfigList}
            configType="Productivity Hour (%)"
          />
        ),
      },
      {
        Header: "Quantity QC Productivity Per Hour",
        accessor: "quantity",
        align: "center",
        Cell: ({ value }) => (
          <NumberColorCell
            value={value}
            configData={updatedConfigList}
            configType="Productivity Hour (%)"
          />
        ),
      },
    ];

    //console.log(newColumnsQC,"new column qc");

     setQCTableData(prev => ({
       ...prev,
       columns: newColumnsQC
     }));
  }, [updatedConfigList]);
  
  return (
    <DashboardLayout>
      <MDBox  pt={0} pb={3}>
      <MDBox mb={3}>
      {/* <DashboardNavbar /> */}
      
        
  <Grid container spacing={3}>
  
    {/* Left side - Table */}
    <Grid item xs={9}>
    <Card>
    <Fieldset label="Setting" 
    // sx={{ marginRight: "2.5rem"}}
     >
                  <Grid container spacing={3}>
                    <Grid item xs={2} sx={{
    "& .MuiInputBase-root": {
      backgroundColor: "#fff9c4",
    },
  }}>
                      <SelectFields
                        field={{
                          name: "team",
                          label: "Team",
                          value: selectedTeam,
                          errors: {},
                          sx: {
                            backgroundColor: '#ffe5e5'
                          },
                        }}
                        options={kpiteamname}
                        onChange={(e, v) => setSelectedTeam(v?.value || "")}
                        InputProps={{
                          style: {
                            backgroundColor: '#ffe5e5'
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <SelectFields
                        field={{
                          name: "",
                          label: "Refresh Rate (Seconds)",
                          value: selectedrefreshrate,
                          errors: {},
                        }}
                        options={[
                          "20",                  
                          "40",
                          "60",
                        ]}
                        onChange={(e, v) => setSelectedRefreshRate(v)}
                      />
                    </Grid>
                    <Grid item xs={2}><MDButton variant="gradient" color="info" onClick={() => setShowFirstTable(!showFirstTable)}>
        Flip
      </MDButton>
      </Grid>
                    <Grid item xs={4}>
                    <CustomDateRangePicker {...customProps} />
                    </Grid>
      <Grid item xs={2}>
  <MDButton variant="gradient" color="info" onClick={handleDownload} disabled={!exportPermission}>
    Export
  </MDButton>
</Grid>
                  </Grid>
                </Fieldset>
        <Box pl={2}>
  <FormTitle title={showFirstTable === true ? "Order Picking" : "Order QC"} />
</Box>
        <MDBox py={1}>
        {isConfigReady ? (
        showFirstTable ? (
          <DataTable
            table={tableData}
            entriesPerPage={false}
            showTotalEntries={false}
            isSorted={false}
            // pagination={{
            //   initialState: { pagination: { pageSize: 7 } }, // sets page size to 7
            // }}
            noEndBorder
          />
        ) : (
          <DataTable
            table={qctableData}
            entriesPerPage={false}
            showTotalEntries={false}
            isSorted={false}
            // pagination={{
            //   initialState: { pagination: { pageSize: 7 } }, // sets page size to 7
            // }}
            noEndBorder
          />
        )
      ) : (
    <MDTypography variant="body2" color="textSecondary" px={2}>
      <b>Please Select a Team to proceed...</b>
    </MDTypography>
  )}
</MDBox>
      </Card>
    </Grid>

    {/* Right side - 3 stacked Charts */}
    <Grid item xs={3}>
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <ChannelsChart 
            //chartData={orderAssignData} 
            chartData={showFirstTable ? orderAssignData : qcorderAssignData }
            title={showFirstTable ? "Productivity Range of Orders Assigned and Picked" : "Productivity Range of Orders QC" }
          />
        </Grid>
        <Grid item>
          <ChannelsChart 
            //chartData={quantityAssignData} 
            chartData={showFirstTable ? quantityAssignData : qcquantityAssignData}
            title={showFirstTable ? "Productivity Range of Quantity Items Assigned and Picked" : "Productivity Range of Quantity Items QC" }
            //title="Productivity Range of Quantity Items Assigned and Picked"
          />
        </Grid>
        <Grid item>
        <Grid container spacing={2}>
  {formattedConfigList.map((config, idx) => (
    <Grid item xs={12} md={formattedConfigList.length === 1 ? 12 : 6} key={idx}>
      <SalesTable title={config.title} rows={config.rows} />
    </Grid>
  ))}
</Grid>
        {/* <SalesTable title="Productivity Hour (%)" rows={salesTableData} /> */}
        {/* <SalesTable title="Productivity Hour2 (%)" rows={salesTableData} /> */}
        </Grid>
      </Grid>
    </Grid>
  </Grid>
</MDBox>
        </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

function NormalColorCell({ value}) {
  const theme = useTheme();
  let bgColor = blue[400]; // soft grey default

  return (
    <TableCell align="center" sx={{ verticalAlign: "middle" }}>
      <MDBox
        width="4rem"
        height="2.5rem"
        borderRadius="999px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color={theme.palette.common.white}
        fontWeight="bold"
        sx={{
          backgroundColor: bgColor,
          boxShadow: `0 2px 6px ${theme.palette.grey[600]}88`, // subtle shadow
          transition: "transform 0.2s ease",
          cursor: "default",
          "&:hover": {
            transform: "scale(1.1)",
            boxShadow: `0 4px 12px ${theme.palette.grey[700]}cc`,
          },
        }}
      >
        {value}
      </MDBox>
    </TableCell>
  );
}

function NumberColorCell({ value, configData = [] , configType = "Productivity Hour (%)"}) {
  const theme = useTheme();
  //console.log(configData,"fromnumbercellfirstcolumn");
  let bgColor = theme.palette.grey[400]; // soft grey default

  if (typeof value === "number"  && Array.isArray(configData)) {
    const config = configData.find(cfg => cfg.title === configType);
    if (config) {
      const matched = config.data.find(item => {
        const label = item.label;

        if (label.startsWith("<")) {
          const threshold = parseFloat(label.slice(1));
          return value <= threshold;
        } else if (label.startsWith(">")) {
          const threshold = parseFloat(label.slice(1));
          return value >= threshold;
        } else if (label.includes("~")) {
          const [min, max] = label.split("~").map(Number);
          return value >= min && value <= max;
        }
        return false;
      });

      if (matched) {
        bgColor = matched.color;
      }
    }
  }

  return (
    <TableCell align="center" sx={{ verticalAlign: "middle" }}>
      <MDBox
        width="4rem"
        height="2.5rem"
        borderRadius="999px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color={theme.palette.common.white}
        fontWeight="bold"
        sx={{
          backgroundColor: bgColor,
          boxShadow: `0 2px 6px ${theme.palette.grey[600]}88`, // subtle shadow
          transition: "transform 0.2s ease",
          cursor: "default",
          "&:hover": {
            transform: "scale(1.1)",
            boxShadow: `0 4px 12px ${theme.palette.grey[700]}cc`,
          },
        }}
      >
        {value}
      </MDBox>
    </TableCell>
  );
}

//for normal KPI
function ProgressBarCell({ user, done, total, configData = [], configType = "User KPI (%)" }) {
  const theme = useTheme();
  const percentage = total > 0 ? Math.round((done / total) * 100) : 0;
  //console.log(configData,"from progress bar cell");
  let barColor = theme.palette.grey[400];
  if (typeof done === "number" && Array.isArray(configData)) {
    const config = configData.find(cfg => cfg.title === configType);
    //console.log(config);
    if (config) {
      //console.log(config)
      const matched = config.data.find(item => {
        const label = item.label;

        if (label.startsWith("<")) {
          const threshold = parseFloat(label.slice(1));
          return percentage <= threshold;
        } else if (label.startsWith(">")) {
          const threshold = parseFloat(label.slice(1));
          return percentage >= threshold;
        } else if (label.includes("~")) {
          const [min, max] = label.split("~").map(Number);
          return percentage >= min && percentage <= max;
        }

        return false;
      });

      if (matched) {
        barColor = matched.color;
      }
    }
  }

  // if (percentage < 25) barColor = theme.palette.error.main;
  // else if (percentage < 50) barColor = theme.palette.warning.main;
  // else if (percentage < 75) barColor = theme.palette.success.main;
  // else barColor = blue[500];

  return (
    <TableCell align="center" sx={{ verticalAlign: 'middle'  ,width: "250px",
      maxWidth: 300, }} >
      <Box width="100%">
        <Typography
          variant="body2"
          sx={{ fontWeight: 'bold', mb: 0.5 }}
        >
          {done}/{total}
        </Typography>

        {/* Outer track container */}
        <Box
          sx={{
            width: '100%',
            height: 8,
            borderRadius: 5,
            backgroundColor: theme.palette.grey[300],
            overflow: 'hidden',
          }}
        >
          {/* Actual progress fill */}
          <Box
            sx={{
              height: '100%',
              width: `${percentage}%`,
              backgroundColor: barColor,
              transition: 'width 0.3s ease-in-out',
            }}
          />
        </Box>
      </Box>
    </TableCell>
  );
}

//for QC KPI
function ProgressBarCell2({ user, done, total }) {
  const theme = useTheme();
  const percentage = total > 0 ? Math.round((done / total) * 100) : 0;

  let barColor = theme.palette.grey[400];
  if (percentage < 25) barColor = theme.palette.error.main;
  else if (percentage < 50) barColor = theme.palette.warning.main;
  else if (percentage < 75) barColor = theme.palette.success.main;
  else barColor = blue[500];

  return (
    <TableCell align="center" sx={{ verticalAlign: 'middle'  ,width: "250px",
      maxWidth: 300, }} >
      <Box width="100%">
      <Box display="flex" justifyContent="space-between" alignItems="center">
  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
    {done}
  </Typography>
</Box>
      </Box>
    </TableCell>
  );
}

export default KPIDashboard;
